/**
 * AKCNSTUDIOS — Global Parallax Engine
 * Dasselbe System wie studio.liquid, aber zentral für alle Sections.
 *
 * Verwendung in HTML-Elementen:
 *   data-px="0.35"          → Scrollgeschwindigkeit (0.1 subtil · 0.4 stark)
 *   data-px-hero            → Hero-Modus: bewegt sich relativ zu absolutem ScrollY
 *                             (für Fullscreen-Backgrounds ganz oben)
 *   Ohne data-px-hero       → Viewport-Modus: relativ zur Bildschirmmitte
 *                             (für Elemente weiter unten auf der Seite)
 *
 * Beispiel:
 *   <img class="hero__bg-image" data-px="0.35" data-px-hero ...>
 *   <img class="story__img" data-px="0.1" ...>
 */

(function () {
  'use strict';

  /* Reduced-motion: kein Parallax wenn Nutzer das bevorzugt */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var items   = [];
  var ticking = false;

  /* ── INIT: alle [data-px] Elemente registrieren ── */
  function init() {
    document.querySelectorAll('[data-px]').forEach(function (el) {
      var speed  = parseFloat(el.getAttribute('data-px')) || 0.3;
      var isHero = el.hasAttribute('data-px-hero');
      items.push({ el: el, speed: speed, hero: isHero });
    });

    if (!items.length) return;

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ── SCROLL: throttled via rAF ── */
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  /* ── UPDATE: Transforms setzen ── */
  function update() {
    var scrollY  = window.scrollY;
    var vh       = window.innerHeight;

    items.forEach(function (item) {
      var el   = item.el;
      var rect = el.getBoundingClientRect();

      /* Nur rendern wenn Element im oder nahe am Viewport */
      if (rect.bottom < -300 || rect.top > vh + 300) {
        ticking = false;
        return;
      }

      var offset;

      if (item.hero) {
        /* Hero-Modus: absoluter Scroll → Bild bewegt sich nach unten */
        offset = scrollY * item.speed;
      } else {
        /* Viewport-Modus: Abstand von Bildschirmmitte → natürlichere Tiefe */
        var elCenter = rect.top + rect.height / 2;
        offset = (elCenter - vh / 2) * item.speed;
      }

      /* Bestehende scale() beibehalten, nur translateY ergänzen */
      var existingScale = el.getAttribute('data-px-scale') || '';
      if (existingScale) {
        el.style.transform = existingScale + ' translateY(' + offset + 'px)';
      } else {
        el.style.transform = 'translateY(' + offset + 'px)';
      }
    });

    ticking = false;
  }

  /* ── START ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
